import OpportunityStatus from '@/constants/OpportunityStatus';

const OpportunitiesFilterParams = {
  archived: {
    type: String,
    defaultValue: OpportunityStatus.ACTIVE,
  },
  ageInDays: {
    type: Date,
    isDefault: true,
  },
  askAmount: {
    type: Number,
  },
  assigneeIds: {
    type: String,
  },
  campaignId: {
    type: String,
  },
  constituentLabelIds: {
    type: Array,
  },
  confidenceLevelIds: {
    type: Array,
  },
  constituentType: {
    type: String,
  },
  constituentCategories: {
    type: Array,
  },
  confidence: {
    type: Number,
  },
  expectedAmount: {
    type: Number,
  },
  groupingType: {
    type: String,
  },
  opportunityLabelIds: {
    type: Array,
  },
  opportunityStageIds: {
    type: Array,
  },
  ownerIds: {
    type: Array,
  },
  projected: {
    type: Number,
  },
  stage: {
    type: Date,
  },
} as const;

export default OpportunitiesFilterParams;
